import { render, staticRenderFns } from "./adminReviewList.vue?vue&type=template&id=027c8df3"
import script from "./adminReviewList.vue?vue&type=script&lang=js"
export * from "./adminReviewList.vue?vue&type=script&lang=js"
import style0 from "./adminReviewList.vue?vue&type=style&index=0&id=027c8df3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports